<template>
  <section>
    <aRow>
      <aCol
        class="collapse-card"
        v-for="paymentCard in paymentCardRows"
        :key="paymentCard.id"
        :span="24"
      >
        <div class="head" @click="onClickOpenCollapse(paymentCard.id)">
          <aRow :gutter="20">
            <aCol class="id cprimary" :span="1">
              <span class="ico">
                <aIcon type="file-text" />
                <font class="num">{{ paymentCard.id }} </font>
              </span>
            </aCol>

            <aCol class="id-name" :span="11"> CARTA DE CRÉDITO </aCol>

            <aCol class="value" :span="9">
              <aTag :color="'blue'">
                {{
                  formatAnyPricePtBr(
                    tempContract[
                      `payment_methods_payment_card_total_value_${paymentCard.id}${keySuffix}`
                    ]
                  )
                }}
              </aTag>

              <aTag :color="'red'">
                {{
                  formatAnyPricePtBr(
                    tempContract[
                      `payment_methods_payment_card_contract_profit_discount_value_${paymentCard.id}${keySuffix}`
                    ]
                  )
                }}
              </aTag>
            </aCol>

            <aCol class="a-right" :span="3">
              <aButton
                class="ml-5"
                v-if="
                  paymentCard.id > 1 && paymentCardRows.length == paymentCard.id
                "
                size="small"
                type="danger"
                shape="circle"
                icon="delete"
                @click="removePaymentCard(paymentCard.id - 1)"
                ghost
              >
              </aButton>
            </aCol>
          </aRow>
        </div>

        <div class="content" v-if="openCollapse == paymentCard.id">
          <PaymentCardCollapseRows
            :contract="contract"
            :tempContract="tempContract"
            :form="form"
            :paymentCardId="paymentCard.id"
            :reservation_total_price="reservation_total_price"
            :keyPrefix="keyPrefix"
            :keySuffix="keySuffix"
            @verifyTotal="verifyTotal"
          />
        </div>
      </aCol>
    </aRow>

    <div class="a-center mb-40 mt-20">
      <aButton
        type="primary"
        @click="addPaymentCard(paymentCardRows.length)"
        ghost
      >
        Adicionar carta de crédito
      </aButton>

      <aFormItem class="none">
        <aInput v-decorator="[`payment_card_rows${keySuffix}`]" />
        <aInput
          v-decorator="[`payment_methods_payment_card_total_value${keySuffix}`]"
        />
      </aFormItem>
    </div>
  </section>
</template>

<script>
import { parse } from "vue-currency-input";
import formatThings from "@/mixins/general/formatThings.js";
import PaymentCardCollapseRows from "../collapses/PaymentCardCollapseRows.vue";

export default {
  name: "PaymentCardTabModal",
  components: { PaymentCardCollapseRows },
  props: {
    form: Object,
    contract: Object,
    tempContract: Object,
    keyPrefix: String,
    keySuffix: String,
    reservation_total_price: Number,
  },
  mixins: [formatThings],
  data() {
    return {
      openCollapse: 0,
      paymentCardRows: [
        {
          id: 1,
        },
      ],
    };
  },
  mounted() {
    if (this.tempContract[`payment_card_rows${this.keySuffix}`] != undefined) {
      this.paymentCardRows = JSON.parse(
        this.tempContract[`payment_card_rows${this.keySuffix}`]
      );
    }

    const rowsStr = JSON.stringify(this.paymentCardRows);

    this.form.setFieldsValue({
      [`payment_card_rows${this.keySuffix}`]: rowsStr,
    });

    this.tempContract[`payment_card_rows${this.keySuffix}`] = rowsStr;

    setTimeout(() => {
      this.calcPaymentCardTotal();
    }, 100);
  },
  methods: {
    verifyTotal() {
      this.calcPaymentCardTotal();
    },
    calcPaymentCardTotal() {
      let total = 0;
      this.paymentCardRows.forEach((pCard) => {
        total += parse(
          this.tempContract[
            `payment_methods_payment_card_total_value_${pCard.id}${this.keySuffix}`
          ]
        );
      });

      this.tempContract[
        `payment_methods_payment_card_total_value${this.keySuffix}`
      ] = total.toString().replace(".", ",");

      this.form.setFieldsValue({
        [`payment_methods_payment_card_total_value${this.keySuffix}`]: total
          .toString()
          .replace(".", ","),
      });

      this.$emit("updateTotalValue");
    },
    addPaymentCard(id) {
      this.paymentCardRows.push({
        id: id + 1,
      });

      this.tempContract[`payment_card_rows${this.keySuffix}`] = JSON.stringify(
        this.paymentCardRows
      );

      this.form.setFieldsValue({
        [`payment_card_rows${this.keySuffix}`]: JSON.stringify(
          this.paymentCardRows
        ),
      });

      this.calcPaymentCardTotal();
    },
    removePaymentCard(index) {
      for (var i in this.paymentCardRows) {
        if (i == index) {
          this.paymentCardRows.splice(i, 1);
          break;
        }
      }

      this.tempContract[`payment_card_rows${this.keySuffix}`] = JSON.stringify(
        this.paymentCardRows
      );

      this.form.setFieldsValue({
        [`payment_card_rows${this.keySuffix}`]: JSON.stringify(
          this.paymentCardRows
        ),
      });

      this.calcPaymentCardTotal();
    },
    onClickOpenCollapse(id) {
      if (id == this.openCollapse) {
        this.openCollapse = 0;
      } else {
        this.openCollapse = id;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.ant-btn-danger
  border:  0 !important
  font-size: 17px !important
  box-shadow: none !important
.duplicate
  border:  0 !important
  color: #4B8AD6 !important
  box-shadow: none !important
  font-size: 17px !important
.collapse-card
  .content
    padding: 30px 20px 20px
    border: 1px solid #ccc
    margin-top: -14px
    border-radius: 0 0 6px 6px
    margin-bottom: 11px
    background: #fff
  .head
    cursor: pointer
    clear: both
    padding:  20px
    background: #fff
    border: 1px solid #ccc
    margin-bottom: 10px
    border-radius: 6px
    .id
      color: #474747
      font-weight: 600
      .ico
        position: relative
        font-size: 14px
      .num
        position: absolute
        right: -13px
        top: 0
        font-size: 11px
        color: #333
    .id-name
      padding-left: 20px !important
      color: #42413f
      font-weight: 500
      text-transform: uppercase
    .value
      font-size: 10px
      color: #42413f
      font-weight: 500
      text-transform: uppercase
</style>
